export default {
  GET_HOME_DATA: 'GET_HOME_DATA',
  GET_HOME_DATA_SUCCESS: 'GET_HOME_DATA_SUCCESS',
  GET_MY_IP: 'GET_MY_IP',
  GET_MY_IP_SUCCESS: 'GET_MY_IP_SUCCESS',
  UPDATE_CART_ITEMS: 'HOME/UPDATE_CART_ITEMS',
  UPDATE_DRAFT_ORDERS: 'HOME/UPDATE_DRAFT_ORDERS',
  UPDATE_NETWORK_STATE: 'HOME/UPDATE_NETWORK_STATE',

  UPDATE_POS_DEVICES_CART_ITEMS: 'UPDATE_POS_DEVICES_CART_ITEMS',
  UPDATE_COUNT_NOTIFY: 'UPDATE_COUNT_NOTIFY',
  UPDATE_EVENTS: 'UPDATE_EVENTS'
};
